var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.icon},[(_vm.type && _vm.type.iconNew)?_c('vs-tooltip',{attrs:{"text":_vm.type.title,"active":true}},[_c('app-icon',{attrs:{"name":_vm.type.iconNew}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }